<template>
  <div class="relative flex h-full flex-col">
    <div
      v-if="title || href"
      class="mb-5 flex justify-between gap-5 leading-[38px]"
    >
      <h2
        class="font-roboto text-[32px] font-medium text-new-test-black"
        @click="handleTitleClick"
      >
        {{ title }}
      </h2>
      <Component
        :is="linkComponent.component"
        v-if="!isLessThanHorizontalPad && href"
        v-bind="linkComponent.props"
        class="whitespace-nowrap text-[18px] font-medium text-new-test-black"
      >
        Смотреть все
      </Component>
    </div>

    <slot></slot>
  </div>
</template>

<script setup>
const NuxtLink = resolveComponent('NuxtLink');
const props = defineProps({
  title: {
    type: String,
    required: true,
  },

  href: {
    type: String,
    default: '',
  },

  isExternalLink: {
    type: Boolean,
    default: false,
  },
});

const router = useRouter();
const { isLessThanHorizontalPad } = useBreakpoint();

const linkComponent = computed(() => {
  if (props.isExternalLink) {
    return { component: 'a', props: { href: props.href, target: '_blank' } };
  }

  return { component: NuxtLink, props: { to: props.href } };
});

const handleTitleClick = () => {
  if (!props.href || !isLessThanHorizontalPad.value) {
    return;
  }

  if (props.isExternalLink) {
    window.open(props.href, '_blank');
    return;
  }

  router.push(props.href);
};
</script>
